import { defineStore } from 'pinia';
// eslint-disable-next-line import/prefer-default-export
export const useStudioStore = defineStore({
    id: 'studio',
    state: () => ({
        studioDetails: {},
    }),
    getters: {},
    actions: {
        loadStudioDetails(details) {
            this.studioDetails = details;
        },
    },
});
